import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { FAKE_STRING, LOADING_STRING } from '@elio/shared/models';
import {
  TRANSLOCO_CONFIG,
  TRANSLOCO_LOADER,
  TRANSLOCO_MISSING_HANDLER,
  Translation,
  TranslocoLoader,
  TranslocoMissingHandler,
  TranslocoModule,
  translocoConfig,
} from '@ngneat/transloco';
import { AVAILABLE_LOCALES, FALLBACK_LANG } from 'scoped-translations';

export class CustomHandler implements TranslocoMissingHandler {
  handle(key: string) {
    if (key !== FAKE_STRING) {
      console.error(`missing key => ${key}`);
    }
    return LOADING_STRING;
  }
}

export const customMissingHandler = {
  provide: TRANSLOCO_MISSING_HANDLER,
  useClass: CustomHandler,
};

export const RE_RENDER_ON_LANG_CHANGE = true;

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: AVAILABLE_LOCALES,
        defaultLang: FALLBACK_LANG,
        fallbackLang: FALLBACK_LANG,
        reRenderOnLangChange: RE_RENDER_ON_LANG_CHANGE,
        prodMode: true,
        missingHandler: {
          useFallbackTranslation: true,
        },
      }),
    },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
    customMissingHandler,
  ],
})
export class TranslocoRootModule {}
